<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep1ogmmr.vue
*@ 컴포넌트설명 :[미얀마] 예금 상품 > 금리 안내(정기예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
** 2022.01.17   이가영  중도해지이율 추가  
** 2022.02.08   이경호  API호출 및 탬플릿 변경
********************************************************************************/
-->

<template>
  <div>
    <div class="cont-tit">
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>

    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
          <th scope="col">MMK</th>
          <th scope="col">USD</th>
        </tr>
      </thead>

      <tbody v-if="irList.length > 0">
        <tr v-for="(ir, i) in irList" :key="i">
          <td>
            <template v-if="lang == $config.LANG_KOR">
              {{ ir.aplyTrmCtntKor }}
            </template>
            <template v-else-if="lang == $config.LANG_ENG">
              {{ ir.aplyTrmCtntEng }}
            </template>
            <template v-else-if="lang == $config.LANG_MMR">
              {{ ir.aplyTrmCtntLcal }}
            </template>
          </td>
          <td>{{ ir.mmkRate }}</td>
          <td>{{ ir.usdRate }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  components: {},
  data() {
    return {
      currentTab: 0,

      irList: [],
    };
  },
  computed: {
    ...mapFields(["lang"]),
  },

  created() {
    this.go();
  },

  methods: {
    go() {
      const path = "/deposit/interest/intRateMm2List";

      let params = {
        interestInqInItemDTO: {
          aplyStartYmd: "",
          cncycd: "",
          dpostLnDstcd: "D",
          operGroupCd: "MM2",
          ppsnCorpCtnt: "",
          prdctKndCtnt: "MM202"
        },
      };

      this.$post(
        path,
        params,
        this.selectSucc
      );
    },

    selectSucc(res) {
      this.irList = res.interstList;
    },
  },
};
</script>